"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _AppBar = require("material-ui/AppBar");

var _AppBar2 = _interopRequireDefault(_AppBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AppBarUi = function AppBarUi(props) {
  return _react2.default.createElement(_AppBar2.default, props);
};

exports.default = AppBarUi;


AppBarUi.propTypes = {};


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/components/AppBar/index.js
// module id = ../lib/egov-ui-kit/components/AppBar/index.js
// module chunks = 504